export default __webpack_public_path__ + "static/media/NewYork.2d8a8e53.jpg";